import React, { useCallback, useEffect, useRef, useState } from "react";
import { useParams } from "react-router-dom";

// Img
import brideImg from "../../assets/png/bride.png";

// Mui
import { Box } from "@mui/material";

// Jds
import {
  ActionButton,
  Button,
  Container,
  Icon,
  Image,
  Notifications,
  Text,
  Tooltip,
} from "@jds/core";
import JdsModal from "./JdsModal";
import NameOfFaceForm from "./Form/NameOfFaceForm";
import GridContainer from "../Layout/GridContainer";
import useApiHttp from "../../hooks/use-http";
import EmptyState from "../NoData/EmptyState";
import FsLightbox from "fslightbox-react";
import { useDispatch } from "react-redux";
import { uploadPhotosActions } from "../../store/state-slices/photosUpload";
import {
  addParamsURL,
  downloadFile,
  getFileNameFromDisposition,
  makeZipImages,
} from "../../util/helper";
import Loader from "./Loader/Loader";
import decryptUrl from "../../util/img-decryption";
import { LazyLoadImage } from "react-lazy-load-image-component";
import "react-lazy-load-image-component/src/effects/blur.css";
export default function FaceListModal({
  data: faceData,
  modalUsername = "",
  setModalUsername = () => {},
  faceCount = 0,
  setFaceCount = () => {},
  isFaceLisModalClosed = true,
  setIsFaceModalClose = () => {},
  setEditModalClose = () => {},
  setSharePhotosModalClose = () => {},
}) {
  const { id: eventId } = useParams();

  const dispatch = useDispatch();
  const [faceList, setFaceList] = useState([]);
  const [previewImgArr, setPreviewImgArr] = useState([]);
  const [downloadLoading, setDownloadLoading] = useState(false);
  const [page, setPage] = useState(0);
  const [lastPage, setLastPage] = useState(0);
  const [isDeleteModalClose, setDeleteModalClose] = useState(true);
  const [deletePhotoId, setDeletePhotoId] = useState(null);
  const [lightboxController, setLightboxController] = useState({
    toggler: false,
    slide: 1,
  });
  const [clusterId, setClusterId] = useState();
  const [mergeClusterId, setMergeClusterId] = useState();
  const [croppedFaceUrl, setCroppedFaceUrl] = useState();
  const { sendRequest: getFaceList, isLoading: isGetFaceListLoading } =
    useApiHttp();
  const { sendRequest: deleteImgReq, isLoading: deleteImgReqing } =
    useApiHttp();
  const { sendRequest: downloadRequest, isLoading: imageIsDownloading } =
    useApiHttp();

  const openLightboxOnSlide = (number) => {
    setLightboxController({
      toggler: !lightboxController.toggler,
      slide: number,
    });
  };

  const deleteImage = (mediaId) => {
    const deleteIds = mediaId;

    const formData = new FormData();
    formData.append("eventId", eventId);
    formData.append("mediaIDs", deleteIds);
    deleteImgReq(
      {
        url: `image/delete`,
        method: "DELETE",
        base: "MEDIA",
        formData: true,
        body: formData,
      },
      null,
      (data) => {
        Notifications.toast.success({
          id: "delete-photos",
          tilte: data.message,
        });
        setDeleteModalClose(true);
        setFaceCount((pre) => pre - 1);
        setFaceList((pre) => pre.filter((item) => item.mediaId !== mediaId));
      },
      (err, data) =>
        Notifications.toast.error({ id: "delete-photos", tilte: data.message })
    );
  };

  const downloadImg = (
    index = 0,
    isMultiple = false,
    fileUrl = "",
    mediaId
  ) => {
    const formData = new FormData();
    // formData.append(
    //   "imageUrl",
    //   index !== null ? faceList[index]?.originalFileSignedPath : fileUrl
    // );
    formData.append("eventId", eventId);
    formData.append("mediaId", mediaId);
    return new Promise((resolve, reject) => {
      downloadRequest(
        {
          url: `organizer/download`,
          method: "POST",
          base: "MEDIA",
          // formData: true,
          // body: formData,
          body: {
            eventId,
            mediaId,
          },
        },
        null,
        (data, res) => {
          const imageUrl = URL.createObjectURL(data);
          const fileName = getFileNameFromDisposition(res);
          if (!isMultiple) {
            downloadFile(imageUrl, fileName);
            Notifications.toast.success({
              id: "download-photos",
              title: "Image Downloaded",
            });
          } else {
            dispatch(uploadPhotosActions.setUploadCount(index + 1));
            resolve({ data, res }); // Resolve the Promise with the imageUrl
          }
        },
        (err, data) => {
          Notifications.toast.error({
            id: "download-photos-error",
            title: data?.message,
          });
          reject(err);
        }
      );
    });
  };
  const downloadMultipleImg = async (files) => {
    dispatch(uploadPhotosActions.setIsStarted(true));
    dispatch(uploadPhotosActions.setIsDownload(true));
    let downloadedImageBlobs = [];
    dispatch(uploadPhotosActions.setTotalCount(files.length));
    for (let i = 0; i < files.length; i++) {
      try {
        const { data: blob, res } = await downloadImg(
          i,
          true,
          "",
          files[i]?.mediaId
        );
        downloadedImageBlobs.push({
          blob,
          filename: getFileNameFromDisposition(res),
        });
      } catch (err) {
      } finally {
        if (i + 1 == files.length) {
          makeZipImages(downloadedImageBlobs, "face-gallery");
          setDownloadLoading(false);
          dispatch(uploadPhotosActions.setTotalCount(0));
          dispatch(uploadPhotosActions.setUploadCount(0));
          dispatch(uploadPhotosActions.setIsDownload(false));
          dispatch(uploadPhotosActions.setIsStarted(false));
        }
      }
    }
  };

  const getFaceListHandler = () => {
    if (clusterId) {
      getFaceList(
        {
          url: `face/cluster-images?eventId=${eventId}&clusterId=${clusterId}&mergeClusterId=${
            mergeClusterId
          }&page=${page}&size=20`,
          base: "MEDIA",
        },
        null,
        (data) => {
          setFaceCount(data?.count);
          if (page == 0) {
            setFaceList(data?.data);
            setPreviewImgArr(
              data?.data?.map((item, i) => (
                <div
                  style={{
                    position: "relative",
                    zIndex: 2,
                    opacity: 0,
                    transform: "translateZ(0)",
                    margin: "auto",
                    backfaceVisibility: "hidden",
                    textAlign: "center",
                    height: "auto !important",
                  }}
                >
                  <PhotoInDiv
                    item={item}
                    eventId={eventId}
                    setLightboxController={setLightboxController}
                    getFaceListHandler={getFaceListHandler}
                    setModalUsername={setModalUsername}
                    setCroppedFaceUrl={setCroppedFaceUrl}
                    setPreviewImgArr={setPreviewImgArr}
                    setPage={setPage}
                    setFaceList={setFaceList}
                    page={page}
                    setClusterId={setClusterId}
                  />
                </div>
              ))
            );
            setLastPage(data?.lastPage);
          } else {
            setFaceList((prev) => [...prev, ...data?.data]);
            setPreviewImgArr((prev) => [
              ...prev,
              ...data?.data?.map((item) => (
                <div
                  style={{
                    position: "relative",
                    zIndex: 2,
                    opacity: 0,
                    transform: "translateZ(0)",
                    margin: "auto",
                    backfaceVisibility: "hidden",
                    textAlign: "center",
                    height: "auto !important",
                  }}
                >
                  <PhotoInDiv
                    item={item}
                    eventId={eventId}
                    setLightboxController={setLightboxController}
                    getFaceListHandler={getFaceListHandler}
                    setModalUsername={setModalUsername}
                    setCroppedFaceUrl={setCroppedFaceUrl}
                    setPreviewImgArr={setPreviewImgArr}
                    setPage={setPage}
                    setFaceList={setFaceList}
                    page={page}
                    setClusterId={setClusterId}
                  />
                </div>
              )),
            ]);

            setLastPage(data?.lastPage);
          }
          console.log("user1234", data);
        }
      );
    }
  };

  //element observer
  const observerRef = useRef(null);
  const lastElementRef = useCallback(
    (node) => {
      if (isGetFaceListLoading) return;
      if (observerRef.current) observerRef.current.disconnect();
      observerRef.current = new IntersectionObserver((element) => {
        if (element[0].isIntersecting && lastPage > page) {
          setPage((pre) => pre + 1);
        }
      });
      if (node) observerRef.current.observe(node);
    },
    [isGetFaceListLoading, lastPage]
  );

  useEffect(() => {
    setModalUsername(faceData?.username);
    setClusterId(faceData?.clusterId);
    setMergeClusterId(faceData?.mergeClusterId);
    setCroppedFaceUrl("");
  }, [
    faceData?.username,
    isFaceLisModalClosed,
    faceData?.clusterId,
    faceData?.mergeClusterId,
  ]);

  useEffect(() => {
    if (isFaceLisModalClosed) {
      setPage(0);
    }
  }, [isFaceLisModalClosed]);

  useEffect(() => {
    if (!isFaceLisModalClosed) {
      getFaceListHandler();
    }
  }, [page, clusterId, isFaceLisModalClosed]);
  useEffect(() => {
    setPreviewImgArr([]);
  }, [clusterId]);
  useEffect(() => {
    setPreviewImgArr(
      faceList.map((item, i) => (
        <div
          style={{
            position: "relative",
            zIndex: 2,
            opacity: 0,
            transform: "translateZ(0)",
            margin: "auto",
            backfaceVisibility: "hidden",
            textAlign: "center",
            height: "auto !important",
          }}
        >
          <PhotoInDiv
            item={item}
            eventId={eventId}
            setLightboxController={setLightboxController}
            getFaceListHandler={getFaceListHandler}
            setModalUsername={setModalUsername}
            setCroppedFaceUrl={setCroppedFaceUrl}
            setPreviewImgArr={setPreviewImgArr}
            setPage={setPage}
            setFaceList={setFaceList}
            page={page}
            setClusterId={setClusterId}
          />
        </div>
      ))
    );
  }, [faceList]);
  return (
    <>
      {isGetFaceListLoading && page == 0 ? (
        <Loader size="small" />
      ) : faceList.length ? (
        <>
          <div id="face-list-modal">
            <GridContainer
              minWidth="159px"
              maxWidth="159px"
              style={{
                maxHeight: "400px",
                overflow: "auto",
                gridTemplateColumns: "repeat(3, 1fr)",
              }}
            >
              {faceList.map((item, i) => (
                <Box
                  key={i}
                  sx={{
                    position: "relative",
                    "& .lazy-load-image-background": {
                      width: "100%",
                      // height: '100%',
                    },
                  }}
                  onClick={() => {
                    openLightboxOnSlide(i + 1);
                  }}
                  ref={faceList.length === i + 1 ? lastElementRef : null}
                >
                  <LazyLoadImage
                    alt="face"
                    effect="blur"
                    src={addParamsURL(
                      decryptUrl(item?.thumbnailFileSignedPath),
                      {
                        size: "s",
                        width: 500,
                        height: 500,
                      }
                    )}
                    placeholderSrc={addParamsURL(
                      decryptUrl(item?.thumbnailFileSignedPath),
                      {
                        size: "s",
                        width: 500,
                        height: 500,
                      }
                    )}
                    style={{
                      objectFit: "cover",
                      // width: "162px",
                      // height: "162px",
                      width: "100%",
                      height: "100%",
                      aspectRatio: 1,
                      borderRadius: "24px",
                    }}
                  />
                  {item?.thumbnailFileSignedPath && (
                    <Container
                      style={{
                        position: "absolute",
                        right: "8px",
                        bottom: "8px",
                        gap: "5px",
                      }}
                    >
                      {/* <ActionButton
                      key={item.id}
                      type="secondary"
                      size="small"
                      icon={"IcDownload"}
                      onClick={(e) => {
                        e.stopPropagation();

                        downloadImg(
                          null,
                          undefined,
                          item.originalFileSignedPath
                        );
                      }}
                    /> */}
                      <Button
                        key={item.id}
                        type="secondary"
                        size="small"
                        icon={"IcDownload"}
                        onClick={(e) => {
                          e.stopPropagation();
                          downloadImg(
                            null,
                            undefined,
                            item.originalFileSignedPath,
                            item?.mediaId
                          );
                        }}
                      />
                      <Button
                        key={item.mediaId}
                        type="secondary"
                        size="small"
                        icon={"IcTrash"}
                        onClick={(e) => {
                          e.stopPropagation();
                          setDeleteModalClose(false);
                          setDeletePhotoId(item.mediaId);
                        }}
                      />
                      {/* <button
                      onClick={(e) => {
                        e.stopPropagation();

                        downloadImg(
                          null,
                          undefined,
                          item.originalFileSignedPath
                        );
                      }}
                    >
                      hello
                    </button> */}
                    </Container>
                  )}
                </Box>
              ))}
              {isGetFaceListLoading && page !== 0 && (
                <Loader
                  size="small"
                  containerProps={{ style: { height: "100%" } }}
                />
              )}
            </GridContainer>
          </div>
          <Container
            horizontalAlign="center"
            fullWidth
            style={{
              marginTop: "32px",
              gap: "20px",
            }}
            direction="row"
          >
            {/*  */}
            <Button
              label={downloadLoading ? "Downloading" : "Download"}
              kind="secondary"
              size="medium"
              iconLeft="IcDownload"
              onClick={() => {
                setDownloadLoading(true);
                downloadMultipleImg(faceList);
              }}
              loading={downloadLoading}
              appearance=""
            />
            <Button
              label="Edit Name"
              kind="secondary"
              size="medium"
              iconLeft="IcEditPen"
              onClick={() => {
                setEditModalClose(clusterId, modalUsername, croppedFaceUrl);
                setIsFaceModalClose(true);
              }}
            />
            <Button
              label="Share Photos"
              kind="secondary"
              size="medium"
              iconLeft="IcShare"
              onClick={() => {
                setIsFaceModalClose(true);

                setSharePhotosModalClose(
                  clusterId,
                  modalUsername,
                  croppedFaceUrl
                );
              }}
            />
          </Container>
        </>
      ) : (
        <Container fullWidth horizontalAlign="center">
          <EmptyState title="No faces found." action={false} />
        </Container>
      )}
      {previewImgArr.length ? (
        <FsLightbox
          disableLocalStorage={true}
          toggler={lightboxController.toggler}
          sources={previewImgArr}
          slide={lightboxController.slide}
          key={previewImgArr.length}
          onClose={() => {}}
        />
      ) : null}

      <JdsModal
        size="m"
        header="Are you sure you want to delete this photo?"
        kind="dialog"
        primaryCTA={{
          title: "Okay",
        }}
        secondaryCTA={{
          title: "Cancel",
        }}
        close={isDeleteModalClose}
        onClose={() => {
          setDeleteModalClose(true);
        }}
        onPrimaryClick={() => {
          deleteImage(deletePhotoId);
        }}
        onSecondaryClick={() => setDeleteModalClose(true)}
        primaryCtaDisabled={deleteImgReqing}
      />
    </>
  );
}

const PhotoInDiv = ({
  item,
  eventId,
  setLightboxController,
  setModalUsername,
  setCroppedFaceUrl,
  getFaceListHandler,
  setPreviewImgArr,
  setPage,
  page,
  setClusterId,
  setFaceList,
}) => {
  const [scalingFactor, setScalingFactor] = useState(0);
  const [faceDetection, setFaceDetection] = useState(false);
  const [faceDiv, setFaceDiv] = useState([]);
  const { sendRequest: faceDetectionApi, isLoading: isFaceDetectionLoading } =
    useApiHttp();
  const { sendRequest: downloadRequest, isLoading: imageIsDownloading } =
    useApiHttp();

  const faceDetectionHandle = (value) => {
    faceDetectionApi(
      {
        url: `face/show-detected-faces?eventId=${eventId}&mediaId=${value}`,
        method: "GET",
        base: "MEDIA",
      },
      null,
      (data) => {
        setFaceDiv(data?.data);
      }
    );
  };

  const downloadImg = (
    index = 0,
    isMultiple = false,
    fileUrl = "",
    mediaId
  ) => {
    const formData = new FormData();
    // formData.append("imageUrl", fileUrl);
    formData.append("eventId", eventId);
    formData.append("mediaId", mediaId);
    return new Promise((resolve, reject) => {
      downloadRequest(
        {
          url: `organizer/download`,
          method: "POST",
          base: "MEDIA",
          // formData: true,
          body: {
            eventId,
            mediaId,
          },
        },
        null,
        (data, res) => {
          const imageUrl = URL.createObjectURL(data);
          const fileName = getFileNameFromDisposition(res);
          if (!isMultiple) {
            downloadFile(imageUrl, fileName);
            Notifications?.toast?.success("Image Downloaded");
          } else {
            // dispatch(uploadPhotosActions.setUploadCount(index + 1));
            resolve({ data, res }); // Resolve the Promise with the imageUrl
          }
        },
        (err, data) => {
          Notifications?.toast?.error({
            id: "download-photos-error",
            title: data?.message,
          });
          reject(err);
        }
      );
    });
  };

  const imgRef = useRef(null);
  return (
    <>
      <img
        ref={imgRef}
        // src={item?.reducedFileSignedPath}
        src={decryptUrl(item?.reducedFileSignedPath)}
        style={
          {
            // height: "auto !important",
            // maxHeight: "80vh !important",
            // maxWidth: "50vw",
            // width: "auto !important",
          }
        }
      />

      <div
        style={{
          position: "absolute",
          bottom: "15px",
          width: "100%",
          // minWidth: "500px",
          display: "flex",
          justifyContent: "center",
          gap: "20px",
          marginTop: "10px",
          whiteSpace: "nowrap",
        }}
      >
        <ActionButton
          label={`${faceDetection ? "Hides" : "Show detected faces"}`}
          kind="secondary"
          appearance="contrast"
          onClick={(e) => {
            e.stopPropagation();
            faceDetectionHandle(item?.mediaId);
            const originalWidth = imgRef?.current?.naturalWidth;
            const originalHeight = imgRef?.current?.naturalHeight;
            const scalingFactor = Math.min(
              imgRef?.current?.offsetWidth
                ? imgRef?.current?.offsetWidth / originalWidth
                : 0,
              imgRef?.current?.offsetHeight
                ? imgRef?.current?.offsetHeight / originalHeight
                : 0
            );
            setScalingFactor(scalingFactor);

            setFaceDetection((pre) => !pre);
          }}
        />
        <ActionButton
          kind="secondary"
          icon={"IcDownload"}
          label="Download"
          appearance="contrast"
          state={imageIsDownloading ? "loading" : "normal"}
          onClick={(e) => {
            // e.stopPropagation();

            downloadImg(
              null,
              undefined,
              item?.originalFileSignedPath,
              item?.mediaId
            );
          }}
        />
      </div>
      {faceDiv?.map((divItem) => (
        <div
          onClick={(e) => {
            e.stopPropagation();
            // window.location.reload();
            // document.body.style.overflow = "";
            // document.documentElement.style.overflow = "";
            // // Remove fslightbox applied styles
            // document.body.classList.remove("fslightbox-open");
            // const fslightbox = document.querySelector(".fslightbox-container");
            // if (fslightbox) {
            //   fslightbox.style.overflow = "";
            // }

            const closeBtn = document.querySelector(
              'div.fslightbox-toolbar-button[title="Close"]'
            );
            closeBtn.click();
            // setLightboxController((pre) => {
            //   return {
            //     ...pre,
            //     toggler: false,
            //     slide: 1,
            //   };
            // });
            if (divItem?.clusterId !== item?.clusterId) {
              setPreviewImgArr([]);
              setFaceList([]);
              setClusterId(divItem?.clusterId);
              setPage(0);
              setModalUsername(divItem?.username);
              setCroppedFaceUrl(divItem?.croppedFaceUrl);
            }
          }}
          key={divItem?.clusterId}
          className="rectangle"
          style={{
            display: faceDetection ? "block" : "none",
            position: "absolute",
            left: divItem?.xcoordinate * scalingFactor,
            top: divItem?.ycoordinate * scalingFactor,
            width: divItem?.imageWidth * scalingFactor,
            height: divItem?.imageHeight * scalingFactor,
            border: "2px solid #00ff00",
            cursor: "pointer",
            borderRadius: "1px",
          }}
        />
      ))}
    </>
  );
};
